// reducers/emailReducer.js

const initialState = {
    emailUpdateCount: 0,
    emailQueueUpdateCount: 0,
};

const emailReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'EMAIL_RECEIVED':
            return {
                ...state,
                emailUpdateCount: state.emailUpdateCount + 1,
            };
        case 'EMAIL_QUEUE_UPDATE':
            return {
                ...state,
                emailQueueUpdateCount: state.emailQueueUpdateCount + 1,
            };
        default:
            return state;
    }
};

export default emailReducer;
